export const OperationStatusses = {
  InProgress: 'InProgress',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;

export const OperationNames = {
  BulkExportNominations: 'BulkExportNominations',
  SyncProgramEnrolments: 'SyncProgramEnrolments',
} as const;

export type OperationStatusType = typeof OperationStatusses[keyof typeof OperationStatusses];
export type OperationName = typeof OperationNames[keyof typeof OperationNames];

export interface OperationStatus {
    correlationId: string;
    operationName: OperationName;
    status: OperationStatusType;
    progress: number;
}

export interface ProgramEnrolmentSyncSummary {
    totalCount: number;
    syncedCount: number;
    pendingCount: number;
}
